module.exports = __webpack_public_path__ + "cjml_app_pcui/img/pic_03.97be7eae.png";